export const invoiceBatchStatus = [
  { label: 'Aberto', value: 'open' },
  { label: 'Pago', value: 'paid' },
  { label: 'Parcialmente pago', value: 'partially_paid' },
  { label: 'Não pago', value: 'not_paid' },
  { label: 'A pagar', value: 'to_be_paid' }
]
